export default __webpack_public_path__ + "9db4e849c658dcc695562831596cedb0.png";